// extracted by mini-css-extract-plugin
export default {"fr-view":"Empty_fr-view__uCReg","container":"Empty_container__yNZnP","image":"Empty_image__g7RzG","title":"Empty_title__3AxSD"};